import React from 'react';
import { Spinner } from 'reactstrap';
import { useAppSelector } from 'src/app/services/store';
import { useWindowWidth } from 'src/app/utilities/helpers';
import { getShowDownloadAppBanner } from 'src/shared/redux-state/src';

const FullScreenLoader = () => {

  const showDownloadAppBanner = useAppSelector(getShowDownloadAppBanner);
  const width = useWindowWidth();

  return (
    <div className='full-screen-loader' style={{top: showDownloadAppBanner ? (width > 567 ? '86px' : '92px') : '50px'}}>
      <div className='full-screen-loader-wrapper'><Spinner size={'lg'} /></div>
    </div>
  );

};

export default FullScreenLoader;